import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'inner-tooltip',
  templateUrl: './inner-tooltip.component.html',
  styleUrls: ['./inner-tooltip.component.scss']
})
export class InnerTooltipComponent implements OnInit {
  @Input() qTitle: any;
  @Input() text: any;
  @ViewChild('p') public popover: NgbPopover;


  constructor() { }

  ngOnInit() { 
  }

  simulateClick(event) {
      if ( event.keyCode === 13 ){
        //var elem = event.currentTarget;
        event.currentTarget.click();
      } 
   }

  closePopover() {
    this.popover.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/inner-tooltip/inner-tooltip.component.ts